import { Autocomplete, TextField, TextFieldProps } from "@mui/material";
import { useIntl } from "react-intl";

type EvaluationStatusOption = {
  value: boolean;
  labelKey: string;
};

type SelectEvaluationStatusProps = {
  value?: boolean;
  onChange: (v?: boolean) => void;
  label?: string;
  required?: boolean;
  textFieldProps?: Partial<TextFieldProps>;
};

const SelectEvaluationStatus = ({
  value,
  onChange,
  label,
  required,
  textFieldProps,
}: SelectEvaluationStatusProps) => {
  const { formatMessage: t } = useIntl();

  const options: EvaluationStatusOption[] = [
    { value: true, labelKey: "activeLabel" },
    { value: false, labelKey: "inactiveLabel" },
  ];

  const selectedOption = options.find((opt) => opt.value === value) ?? null;

  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: EvaluationStatusOption | null,
  ) => {
    onChange(newValue?.value);
  };

  return (
    <Autocomplete
      value={selectedOption}
      onChange={handleChange}
      options={options}
      getOptionLabel={(option) => t({ id: option.labelKey })}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          label={label}
          variant="standard"
          InputLabelProps={{ required }}
        />
      )}
    />
  );
};

export default SelectEvaluationStatus;
